import { render, staticRenderFns } from "./DoctorPanel.vue?vue&type=template&id=88285a00&scoped=true&"
import script from "./DoctorPanel.vue?vue&type=script&lang=js&"
export * from "./DoctorPanel.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPanel.vue?vue&type=style&index=0&id=88285a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88285a00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDialog,VProgressLinear,VSnackbar})
